export default "__VITE_ASSET__DJh1m2L4__"